<template>
  <div class="bespread-wrap module-layer3">
    <div class="screen-container role-active">
      <div id="gallery" class="gallery">
        <swiper
          :options="swiperOptionTop"
          ref="swiperTop"
          @slideChange="roleNavSlideChange"
        >
          <swiper-slide v-for="(iconItem, idx) in roleList" :key="idx">
            <div class="role " :class="'role-' + iconItem.id">
              <img
                :src="
                  require('../../assets/img/layer3/' +
                    lang +
                    '/name' +
                    (idx + 1) +
                    '.png')
                "
                alt=""
                srcset=""
                class="role-info _role-remark"
              />
              <img
                src="../../assets/img/layer3/vol.png"
                alt=""
                srcset=""
                class="audio-btn cursor _role-remark"
                :class="'role-' + iconItem.id + '-aduio'"
                @click="handleAudio(iconItem)"
              />
              <img
                :src="iconItem.roleIdx"
                alt=""
                srcset=""
                class="roleIdx _role-remark "
              />
              <img
                :src="iconItem.bgIdx"
                alt=""
                srcset=""
                class="bgIdx"
                :class="'role-' + 'bgIdx'"
              />
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-thumbs-prev-role"></div>
        <div class="swiper-thumbs-next-role"></div>
      </div>
    </div>
    <div id="thumbs" class="gallery-thumbs">
      <swiper
        :options="swiperOptionThumbs"
        ref="swiperThumbs"
        @slideChange="thumbsSlideChange"
      >
        <swiper-slide v-for="(r, ix) in roleList" :key="ix">
          <img :src="r.iconSrc" alt="" srcset="" class="thumbs-icon" />
        </swiper-slide>
      </swiper>
    </div>
    <!-- audio -->
    <audio controls="controls" ref="audio" id="nameAttrValue">
      <source :src="musicUrl" type="audio/wav" />
    </audio>
  </div>
</template>
<script>
export default {
  name: "app",
  props: ["language", "changeRoleLang"],

  data() {
    return {
      musicUrl: "", // 音频地址
      lang: localStorage.getItem("sof_locale") || "en",
      iconActive: 1,
      roleList: [
        {
          id: 1,
          roleIdx: require("../../assets/img/layer3/cha/1.png"),
          bgIdx: require("../../assets/img/layer3/cha1-bg.png"),
          iconSrc: require("../../assets/img/layer3/1.png")
        },
        {
          id: 2,
          roleIdx: require("../../assets/img/layer3/cha/2.png"),
          bgIdx: require("../../assets/img/layer3/cha2-bg.png"),
          iconSrc: require("../../assets/img/layer3/2.png")
        },
        {
          id: 3,
          roleIdx: require("../../assets/img/layer3/cha/3.png"),
          bgIdx: require("../../assets/img/layer3/cha3-bg.png"),
          iconSrc: require("../../assets/img/layer3/3.png")
        },
        {
          id: 4,
          roleIdx: require("../../assets/img/layer3/cha/4.png"),
          bgIdx: require("../../assets/img/layer3/cha4-bg.png"),
          iconSrc: require("../../assets/img/layer3/4.png")
        },
        {
          id: 5,
          roleIdx: require("../../assets/img/layer3/cha/5.png"),
          bgIdx: require("../../assets/img/layer3/cha5-bg.png"),
          iconSrc: require("../../assets/img/layer3/5.png")
        },
        {
          id: 6,
          roleIdx: require("../../assets/img/layer3/cha/6.png"),
          bgIdx: require("../../assets/img/layer3/cha6-bg.png"),
          iconSrc: require("../../assets/img/layer3/6.png")
        },
        {
          id: 7,
          roleIdx: require("../../assets/img/layer3/cha/7.png"),
          bgIdx: require("../../assets/img/layer3/cha7-bg.png"),
          iconSrc: require("../../assets/img/layer3/7.png")
        }
      ],
      // nextShow: true,
      swiperOptionTop: {
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        loop: true, // 启用循环
        loopedSlides: 3, // 配合 loop
        allowTouchMove: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-thumbs-next-role",
          prevEl: ".swiper-thumbs-prev-role"
        }
      },
      swiperOptionThumbs: {
        direction: "vertical",
        loop: true, // 启用循环
        loopedSlides: 3, // 配合 loop
        allowTouchMove: true,
        spaceBetween: 10,
        slidesPerView: 3,
        // touchRatio: 0.2,
        // freeMode: true, // 自由模式有助于点击切换
        watchSlidesProgress: true, // 关键：监控进度
        slideToClickedSlide: true, // 当点击缩略图时，让swiperTop同步
        watchSlidesVisibility: true // 监控可见性
      }
    };
  },

  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },

  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    language(newVal, oldVal) {
      this.lang = newVal;
    },
    changeRoleLang(newVal, oldVal) {
      const sTop = this.$refs.swiperTop.swiper;
      const sThumbs = this.$refs.swiperThumbs.swiper;

      if (sTop) {
        this.$nextTick(() => {
          sTop.loopDestroy();
          sTop.loopCreate();
          sThumbs.loopDestroy();
          sThumbs.loopCreate();
        });
      }
    }
  },
  methods: {
    roleNavSlideChange() {
      // let roleActive = this.$refs.swiperTop.swiper.activeIndex;
      // console.log("现在的语言是", localStorage.getItem("sof_locale"));
    },
    thumbsSlideChange() {
      // let thumbsActive = this.$refs.swiperThumbs.swiper.activeIndex;
    },
    handleAudio(val) {
      if (this.lang == "th") {
        this.$refs.audio.src = require(`../../assets/img/layer3/audio/${val.id}-th.wav`);
      } else {
        this.$refs.audio.src = require(`../../assets/img/layer3/audio/${val.id}-en.wav`);
      }
      let audio = this.$refs.audio;
      audio.load();
      audio.play();
    },
    // 滑动箭头的时候，音频不播放
    stopAduio() {
      let audio = this.$refs.audio;
      audio.pause();
    },
    roleNavSlideChange() {
      this.stopAduio();
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer3 {
  // pointer-events: none;

  .gallery-thumbs {
    width: 7.2vw;
    height: 9vw;
    position: absolute;
    top: 13vw;
    left: 2vw;
    .swiper-slide {
      opacity: 1;
      filter: grayscale(100%);
      width: 7.2vw;
      height: 9vw;
    }
    .swiper-slide-active {
      background-color: transparent;
      filter: grayscale(0);
    }
    img {
      width: 100%;
      height: 100%;
    }
    .thumbs-icon {
    }
    .swiper-container {
      height: 27vw;
      width: 7.2vw;
    }
  }

  .screen-container {
    .swiper-slide {
      overflow: hidden;
    }
    .gallery {
      width: 100%;
      height: 100%;
      .swiper-thumbs-prev-role:after,
      .swiper-thumbs-next-role:after {
        display: none;
        cursor: pointer !important;
      }

      .swiper-thumbs-prev-role {
        background: url("../../assets/img/layer3/j-u.png") no-repeat top;
        background-size: 100% 100%;
        width: 4vw;
        height: 3vw;
        top: 9vw;
        left: 3.5vw;
        position: absolute;
        z-index: 2;
      }

      .swiper-thumbs-next-role {
        background: url("../../assets/img/layer3/j-d.png") no-repeat top;
        background-size: 100% 100%;
        width: 4vw;
        height: 3vw;
        top: 40.5vw;
        left: 3.5vw;
        position: absolute;
        z-index: 2;
      }
      .role {
        position: relative;
        width: 100%;
        height: 100%;

        .audio-btn {
          width: 206px;
          height: auto;
          position: absolute;
          left: 19vw;
          top: 24vw;
          z-index: 3;
        }
        .role-info {
          width: auto;
          height: 714px;
          position: absolute;
          left: 8vw;
          top: 2vw;
          z-index: 2;
          // transform: translate(0, -50%);
        }
      }
      // 每个角色尺寸大小需单独设置
      .role .bgIdx {
        // width: 1920px;
        // height: 1080px;
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        right: 0;
        object-fit: cover;
      }
      .role .roleIdx {
        z-index: 1;
      }
      .role-1 {
        .roleIdx {
          width: 1394px;
          height: 1445px;
          position: absolute;
          left: 0;
          top: -14vw;
        }
        // .bgIdx {
        //   background: url("../../assets/img/layer3/cha1-bg.png") no-repeat;
        //   background-size: 100% 100%;
        // }
      }
      .role-2 {
        .roleIdx {
          width: 1431px;
          height: 2262px;
          position: absolute;
          top: -17vw;
          left: 4vw;
        }
      }
      .role-3 .roleIdx {
        width: 1954px;
        height: 1619px;
        position: absolute;
        left: -8vw;
        top: -2vw;
      }
      .role-4 .roleIdx {
        width: 2139px;
        height: 1799px;

        position: absolute;
        left: 1vw;
        top: -1vw;
      }
      .role-5 .roleIdx {
        width: 1735px;
        height: 1976px;
        position: absolute;
        left: 7vw;
        top: -15vw;
      }
      .role-6 .roleIdx {
        width: 1309px;
        height: 1822px;
        position: absolute;
        left: 14vw;
        top: -1.5vw;
      }
      .role-7 .roleIdx {
        width: 1628px;
        height: 1427px;
        position: absolute;
        left: 7vw;
        top: -10vw;
      }
      // 头像icon
      .swiper-pagination-role {
        transition: all 0.5s;
        z-index: 3;
        top: 8vw;
        left: 6%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 0.2vw;
        max-height: 600px;
        border: 1px solid red;

        .my-bullet {
          // display: flex;
          // justify-content: center;
          // width: 156px;
          // height: 185px;
          width: 120px;
          height: 142px;
          filter: grayscale(100%);
          i {
            display: block;
            width: 120px;
            height: 142px;
            z-index: 1;
          }
        }
        .swiper-pagination-bullet-active {
          background-color: transparent;
          filter: grayscale(0);
        }
        .my-bullet0 i {
          background: url("../../assets/img/layer3/1.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet1 i {
          background: url("../../assets/img/layer3/2.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet2 i {
          background: url("../../assets/img/layer3/3.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet3 i {
          background: url("../../assets/img/layer3/4.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet4 i {
          background: url("../../assets/img/layer3/5.png") no-repeat;
          background-size: 100% 100%;
        }
        .my-bullet5 i {
          background: url("../../assets/img/layer3/6.png") no-repeat;
          background-size: 100% 100%;
        }
        .my-bullet6 i {
          background: url("../../assets/img/layer3/7.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .role-active .swiper-slide-active ._role-remark {
    animation: _fadeInRight 0.6s both;
    opacity: 0;
  }
  @keyframes _fadeInRight {
    0% {
      opacity: 0;
      transform: translate3d(20vw, 0, 0);
    }

    to {
      opacity: 1;
      transform: translateZ(0);
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer3 {
    .role-1 .roleIdx {
      top: -11vw !important;
    }
    .role-2 .roleIdx {
      top: -12vw !important;
    }
    .role-3 .roleIdx {
      top: 1vw !important;
    }
    .role-6 .roleIdx {
      top: 0vw !important;
    }
    .role-7 .roleIdx {
      top: -8vw !important;
    }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer3 {
    .role-1 .roleIdx {
      top: -11vw !important;
    }
    .role-2 .roleIdx {
      top: -9vw !important;
    }
    .role-3 .roleIdx {
      top: 1vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer3.vue